import React from "react";
import Reveal from "./Reveal";

export const PageHero = ({ eyebrow, title, sub, image }) => (
  <section className="relative overflow-hidden bg-forest-dark pt-28 pb-16 sm:pt-36 sm:pb-24">
    {image && (
      <>
        <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-gradient-to-t from-forest-dark via-forest-dark/85 to-forest-dark/60" />
      </>
    )}
    <div className="grain absolute inset-0 opacity-40" />
    <div className="relative mx-auto max-w-[1400px] px-4 sm:px-8 lg:px-12">
      <Reveal>
        {eyebrow && (
          <div className="mb-4 font-mono text-xs font-semibold uppercase tracking-[0.28em] text-amber-soft">{eyebrow}</div>
        )}
        <h1 className="max-w-4xl font-display text-4xl font-extrabold leading-[1.08] tracking-tight text-offwhite sm:text-5xl lg:text-6xl">
          {title}
        </h1>
        {sub && <p className="mt-6 max-w-2xl font-body text-base leading-relaxed text-offwhite/75 sm:text-lg">{sub}</p>}
      </Reveal>
    </div>
  </section>
);

export default PageHero;
